import { DealDetails } from "@/classes/DealDetails";
import settings from "@/settings";

const dealHelper = {
    getDealLink: (deal: DealDetails): string => {
        const dealLink = `https://${settings.siteUrl}/Deal/${deal.dealId}/${deal.prettyTitle}`
        console.log(dealLink)
        return dealLink;
    },
    
}

export default dealHelper;